import React from 'react';
import { motion } from 'framer-motion';
import './PinnedStickyNote.css';

/**
 * PinnedStickyNote - A read-only, decorative sticky note pinned to the wall
 * These are former desk sticky notes that have been "preserved" on the wall
 */
const PinnedStickyNote = ({ note, position }) => {
  return (
    <motion.div
      className="pinned-sticky-note"
      style={{
        backgroundColor: note.color || 'var(--color-watercolor-yellow)',
        left: `${position.x}%`,
        top: `${position.y}%`,
      }}
      initial={{ scale: 0, opacity: 0, rotate: -15 }}
      animate={{ scale: 1, opacity: 1, rotate: position.rotation || 0 }}
      transition={{ type: 'spring', stiffness: 300, damping: 25 }}
    >
      {/* Pushpin */}
      <div className="pinned-note-pin">
        <div className="pin-head" />
        <div className="pin-shadow" />
      </div>

      {/* Drawing display */}
      {note.drawing && (
        <img
          src={note.drawing}
          alt="Drawing"
          className="pinned-note-drawing"
        />
      )}

      {/* Text display */}
      {note.text && !note.drawing && (
        <p className="pinned-note-text">{note.text}</p>
      )}

      {/* Author signature */}
      <div className="pinned-note-signature">
        <span>{note.createdBy || 'Unknown'}</span>
      </div>

      {/* Paper texture overlay */}
      <div className="pinned-note-texture" />
    </motion.div>
  );
};

export default PinnedStickyNote;
